var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.17,
    height: 10.85,
    viewBox: "0 0 6.17 10.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42,10.85a.79.79,0,0,1-.53-.22L.22,6a.75.75,0,0,1,0-1.06L4.89.22A.75.75,0,0,1,6,.22.74.74,0,0,1,6,1.28L1.81,5.42,6,9.57a.74.74,0,0,1,0,1.06A.77.77,0,0,1,5.42,10.85Z",
    fill: "#41319c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.96e9d7f96f3f9feda38bf175366d411b.svg";
export { ForwardRef as ReactComponent };